import { useEffect, useMemo } from 'react';
import { PostMessageSentinelEnum, postMessageWrapper, } from '@src/embeds/utils/postMessageWrapper';
export const UPDATE_PLAYER_STATE_SYNC = 'fwn:update_player_state_sync';
export const REMOVE_PLAYER_STATE_SYNC = 'fwn:remove_player_state_sync';
export const GLOBAL_PLAYERS_STATE_SYNC = 'fwn:global_players_state_sync';
export const usePlayerStateDispatcher = ({ params, videoId, layout, openReason, }) => {
    useEffect(() => {
        const playerState = {
            widget_id: params.widget_id,
            app_id: params.app_id,
            channel: params.channel,
            playlist: params.playlist,
            hashtag: params.hashtag,
            videoId,
            layout,
            openReason,
        };
        postMessageWrapper({
            action: UPDATE_PLAYER_STATE_SYNC,
            playerState,
            sentinel: PostMessageSentinelEnum.INTERNAL,
            widgetId: params.widget_id,
        });
    }, [params, layout, videoId, openReason]);
    return useMemo(() => {
        return {
            removePlayerState: () => {
                postMessageWrapper({
                    action: REMOVE_PLAYER_STATE_SYNC,
                    sentinel: PostMessageSentinelEnum.INTERNAL,
                    widgetId: params.widget_id,
                });
            },
        };
    }, [params.widget_id]);
};
